import { Component } from '@angular/core';
import { CountryNames, CifDetails, CorporateUserDetails, CorporateUser, GetCompanyAccounts, GenericResponse, UserProfile } from 'src/app/interfaces/apiresponses'; 
import { FormGroup, FormControl, Validators, AbstractControl, ValidatorFn, ValidationErrors } from '@angular/forms';
import { RestService } from 'src/app/services/rest/rest.service';
import { IItem } from '@coreui/angular-pro'
import * as _ from 'lodash';
import { DatePipe } from '@angular/common';

type CifCurrencyCode = 'USD' | 'EUR'

interface CifThresholdCell {
  threshold: number
  unlimited: boolean
  valid: any
}

@Component({
  selector: 'app-corporate-checker',
  templateUrl: './corporate-checker.component.html',
  styleUrls: ['./corporate-checker.component.scss'],
  providers: [DatePipe]
})
export class CorporateCheckerComponent {
  // Customer Profile Form
  selectedCif: string = ''
  customerProfileForm!:FormGroup
  approvedCustomerProfile: any
  authorityLevelTabLabel: string = 'CIF Level Authorities'
  bUndefined!:boolean
  bShowCifSearchScreen: boolean = true
  searchBtnColor = 'secondary'
  showAllPendingCustomerBtnColor = 'secondary'
  companyName: string = ''
  bLoading: boolean = false
  bShowCustomerDetailsScreen: boolean = false
  bIsProfilePending: boolean = false
  bIsMatrixPending: boolean = false
  bShowingApprovedData: boolean = true
  bHasCustomerMatrixApprovalPending: boolean = false

  // Country list
  countryList: CountryNames | undefined
  
  // Alert buttons
  bAlert = false
  alertHeaderText = ""
  alertBodyText = ""
  bShowSecondAlertButton = false
  alertSecondButtonText = ""
  alertCloseButtonText = "Close"
  alertBoxData: any


  // Selected Customer Details
  selectedItem: any = {}
  originalCustomerDetails: any = {}
  companyId: number = 0
  bSelectedCustomerCIFLevelAuthority: boolean = false
  selectedCustomerDateOfBirth?: Date | null = new Date()
  selectedCustomerIDExpiresOn?: Date | null = new Date()
  selectedCustomerIDType: string = 'Passport'
  selectedCustomerGender: string = 'Male'
  selectedCustomerNationality: string = ''
  bIsSelectedCustomerAuthorityDefined: boolean = false
  selectedCustomerRole: string = 'Maker'
  bIsSelectedCustomerMaker: boolean = false
  selectedCustomerAuthorityLevel: string = 'CIF Level'
  bSelectedCustomerCreateSB: boolean = false
  bSelectedCustomerCreateCurrent: boolean = false
  bSelectedCustomerRequestCertificate: boolean = false
  bSelectedCustomerChangeMobile: boolean = false
  bSelectedCustomerChangeAddress: boolean = false
  bSelectedCustomerChangeEmail: boolean = false
  bSelectedCustomerFullMasterAuthority: boolean = false
  
  // CIF Level Authorities
  bSelectedCustomerViewOnly: boolean = false
  bSelectedCustomerDeactivateAccount: boolean = false
  bSelectedCustomerCanCreateFD: boolean = false
  bSelectedCustomerUnlimitedFDThreshold: boolean = false
  bSelectedCustomerCanMakeInternalTransfer: boolean = false
  bSelectedCustomerUnlimitedInternalTransferThreshold: boolean = false
  bSelectedCustomerCanMakeDhabiTransfer: boolean = false
  bSelectedCustomerUnlimitedDhabiTransferThreshold: boolean = false
  bSelectedCustomerCanMakeForeignTransfer: boolean = false
  bSelectedCustomerUnlimitedForeignTransferThreshold: boolean = false

  SelectedCustomerFDThreshold:number = 0
  bValidFDThreshold!: boolean
  
  SelectedCustomerInternalTransferThreshold: number = 0
  bValidInternalTxThreshold!: boolean

  SelectedCustomerDhabiTransferThreshold: number = 0
  bValidDhabiTxThreshold!: boolean

  SelectedCustomerForeignTransferThreshold: number = 0
  bValidForeignTxThreshold!: boolean

  readonly cifSupportedCurrencies: CifCurrencyCode[] = ['USD', 'EUR']
  readonly cifThresholdRows: Array<{ matrixId: number, label: string }> = [
    { matrixId: 1, label: 'Fixed Deposits' },
    { matrixId: 14, label: 'Internal Transfer' },
    { matrixId: 12, label: 'Transfer within Dhabi' },
    { matrixId: 13, label: 'Foreign Transfer' }
  ]
  cifThresholdState: { [matrixId: number]: { [currency: string]: CifThresholdCell } } = {}

  // Account Level Details
  companyAccounts: string[] = []
  accountCurrencyByNumber: { [accountNumber: string]: string } = {}
  SelectedCustomerAccount: string = ''
  SelectedCustomerAccountPermissions: any

  // Account grid state (read-only view of the per-account permissions table)
  accountMatrixRows: any[] = []
  allAccountsSelected: boolean = false

  // Card Colors
  activeCardColor = { color: 'success', textColor: 'primary' }
  inactiveCardColor = { color: 'danger', textColor: 'secondary' }

  // Tab Controls
  profileTabActive = true
  matrixTabActive = false
  selectedTab = 0
  selectedNextTab = 0

  usersData: IItem[] = []
  selectedItems = [2, 3];
  bApprove:boolean= false;
  bReject:boolean= false;
  columns = [
    {
      key: 'cif',
      label: 'CIF',
      _style: { width: '7vw', minWidth: '7vw', maxWidth: '7vw' },
    },
    {
      key: 'name',
      _style: { width: '20vw', minWidth: '10vw', maxWidth: '30vw' },
    },
    'emailId',
    'mobileNumber',
    {
      key: 'approvalStatus',
      label: 'AML Status',
      _cellProps: { align: 'middle' },
      _style: { width: '7vw', minWidth: '7vw', maxWidth: '7vw' },
    },
    {
      key: 'isMaker',
      label: 'Role',
      _cellProps: {align: 'middle'},
      filter: false
    },
    {
      key: 'isCIFLevelAuthority',
      label: 'Authority Level',
      filter: false
    },
    {
      key: 'isApproved',
      label: 'Status',
      _cellProps: {align: 'middle'},
      filter: false
    }
    
  ];

  constructor(private restApi: RestService,private datePipe: DatePipe){

  }

  // Search Form
  searchCif: string = ''
  cifSearchForm = new FormGroup({
    searchCifControl: new FormControl(this.searchCif, [Validators.required, Validators.minLength(3)])
  })

  // Reject Form
  bShowReason = false
  bValidReason!: boolean
  rejectionReason: string = ''
  rejectionForm = new FormGroup({
    reasonControl: new FormControl(this.rejectionReason, [Validators.required, Validators.minLength(5)])
  })

  get reasonControl() { return this.rejectionForm.get('reasonControl') }

  ifReasonValid(){
    if (this.reasonControl?.invalid && (this.reasonControl?.dirty || this.reasonControl?.touched)){
      this.bValidReason = false
      return 'Enter a valid reason'
    } else {
      if (this.reasonControl?.dirty || this.reasonControl?.touched)
        this.bValidReason = true
      else
        this.bValidReason = this.bUndefined
      return ''
    }
  }

  showReasonModal(){
    this.reasonControl?.setValue('')
    this.rejectionReason = ''
    this.bValidReason = this.bUndefined
    this.bShowReason = true
  }

  closeReasonModal(){
    this.bShowReason = false
  }
  closeRejectModal(){
    this.bReject= false;
    this.goBackToSearchScreen();
  }
  RejectCustomer(){
    if (this.rejectionForm.valid){
      this.bShowReason = false

      // If profile is waiting for approval, reject it
      if (!this.selectedItem.item.isDecisionTaken) {
        this.restApi.approveOrRejectCustomerProfile(this.selectedItem.item.userId, false, this.reasonControl?.value == undefined ? "Rejected" : this.reasonControl?.value).subscribe({
          next: (v: GenericResponse) => {
            if (v.success){
              // Now reject the customer permissions
              this.restApi.approveOrRejectCustomerPermissions(this.selectedItem.item.userId, this.selectedItem.item.reference, false, this.reasonControl?.value == undefined ? "Rejected" : this.reasonControl?.value).subscribe({
                next: (v: GenericResponse) => {
                  if (v.success) {
                    this.bReject= true;
                  } else {
                    this.showAlertBox("Sorry", "Unable to approve the permissions. Please contact technical support")
                  }
                },
                error: (e) => {
                  this.showAlertBox("Sorry", "Unable to approve the permissions. Please contact technical support")
                }
              })
            } else {
              this.showAlertBox("Sorry", "Unable to approve the permissions. Please contact technical support")
            }
          },
          error: (e) => {

          }
        })
      } else {
        this.restApi.approveOrRejectCustomerPermissions(this.selectedItem.item.userId, this.selectedItem.item.reference, false, this.reasonControl?.value == undefined ? "Rejected" : this.reasonControl?.value).subscribe({
          next: (v: GenericResponse) => {
            if (v.success) {
              console.log("Permission rejected")
              this.goBackToSearchScreen();
            } else {
              this.showAlertBox("Sorry", "Unable to approve the permissions. Please contact technical support")
            }
          },
          error: (e) => {

          }
        })
      }
    } else {
      this.bValidReason = false
    }
  }

  askForApproval(){
    this.showAlertBox('Confirm', 'Are you sure you want to approve this Customer? If you say Yes, the Customer will be notified with the changes.', 'No', true, 'Yes', {action: 1, matrixId: 0})
  }

  approveCustomer(){    
    // First approve the profile if required
    if (!this.selectedItem.item.isDecisionTaken) {
      this.restApi.approveOrRejectCustomerProfile(this.selectedItem.item.userId, true, "").subscribe({
        next: (v: GenericResponse) => {
          if (v.success){
            // Now approve the customer permissions
            this.restApi.approveOrRejectCustomerPermissions(this.selectedItem.item.userId, this.selectedItem.item.reference, true, "").subscribe({
              next: (v: GenericResponse) => {
                if (v.success) {
                  //console.log("approve")
                  this.bApprove=true;
                } else {
                  this.showAlertBox("Sorry", "Unable to approve the permissions. Please contact technical support")
                }
              },
              error: (e) => {

              }
            })
          } else {
            this.showAlertBox("Sorry", "Unable to approve the permissions. Please contact technical support")
          }
        },
        error: (e) => {

        }
      })
    } else {
      this.restApi.approveOrRejectCustomerPermissions(this.selectedItem.item.userId, this.selectedItem.item.reference, true, "").subscribe({
        next: (v: GenericResponse) => {
          if (v.success) {
            this.goBackToSearchScreen()
          } else {
            this.showAlertBox("Sorry", "Unable to approve the permissions. Please contact technical support")
          }
        },
        error: (e) => {

        }
      })
    }
  }

  OnCountryList(event: any) {
    if (event.success)
    {
      this.countryList = event.data
      if (this.selectedCustomerNationality) {
        const resolvedNationality = this.resolveNationalityShortCode(this.selectedCustomerNationality)
        this.selectedCustomerNationality = resolvedNationality
        this.customerNationality?.setValue(resolvedNationality)
      }
      console.log('Got country list')
    }
    else {
      this.showAlertBox('Sorry', 'Something wrong with the remote system. Please contact the support')
    }
  }

  private resolveNationalityShortCode(rawNationality: any): string {
    const fallback = (this.selectedCustomerNationality || 'AE').toUpperCase()
    const raw = (rawNationality ?? '').toString().trim()

    if (!raw) {
      return fallback
    }

    const rawUpper = raw.toUpperCase()
    const countries = this.countryList?.dhabiCountries || []

    const byShortCode = countries.find((country: any) =>
      (country?.shortCode || '').toUpperCase() === rawUpper
    )
    if (byShortCode?.shortCode) {
      return byShortCode.shortCode
    }

    const byName = countries.find((country: any) =>
      (country?.countryName || '').trim().toLowerCase() === raw.toLowerCase()
    )
    if (byName?.shortCode) {
      return byName.shortCode
    }

    return rawUpper
  }

  showAlertBox(heading: string, body: string, closeButtonText: string = "Close", showSecondButton: boolean = false, secondButtonText: string = "Understood", data: any = {})
  {
    this.alertHeaderText = heading
    this.alertBodyText = body
    this.bShowSecondAlertButton = showSecondButton
    this.alertSecondButtonText = secondButtonText
    this.alertCloseButtonText = closeButtonText
    this.alertBoxData = data
    this.bAlert = true
  }

  onAlertButtonClick(event: any){
    this.bAlert = event.state

    if (event.data.action === 1){
      this.approveCustomer()
    } else if (event.data.action === 2) {
      this.approveActivationRequest(true)
    }
  }

  closeAlert(event: any){
    

    if (event.data.action === 1){
      this.bAlert = event.state
      // Nothing
    } else if (event.data.action === 2) {
      console.log("Rejection request")
      this.showReasonModal()
    }
  }

  // Activation approval and rejection alert
  bShowActivationReason: boolean = false
  activationApprovalRequestType: string = "DEACTIVATE"
  bValidActivationRejectReason!: boolean
  activationRejectionReason: string = ''
  activationRejectionForm = new FormGroup({
    activationReasonControl: new FormControl(this.activationRejectionReason, [Validators.required, Validators.minLength(5)])
  })

  get activationReasonControl() { return this.activationRejectionForm.get('activationReasonControl') }

  ifActivationReasonValid(){
    if (this.activationReasonControl?.invalid && (this.activationReasonControl?.dirty || this.activationReasonControl?.touched)){
      this.bValidActivationRejectReason = false
      return 'Enter a valid reason'
    } else {
      if (this.activationReasonControl?.dirty || this.activationReasonControl?.touched)
        this.bValidActivationRejectReason = true
      else
        this.bValidActivationRejectReason = this.bUndefined
      return ''
    }
  }

  showActivationReasonModal(item: any){
    if (item.item.isActive){
      this.activationApprovalRequestType = "DEACTIVATE"
    } else {
      this.activationApprovalRequestType = "ACTIVATE"
    }

    this.selectedItem = item
    
    this.activationReasonControl?.setValue('')
    this.activationRejectionReason = ''
    this.bValidActivationRejectReason = this.bUndefined
    this.bShowActivationReason = true
  }

  closeActivationReasonModal(){
    this.bShowActivationReason = false
  }
  closeApproveModal(){
    this.bApprove = false;
    this.goBackToSearchScreen()
  }
  approveActivationRequest(Approve: boolean){
    this.bShowActivationReason = false
//console.log(Approve)
    this.restApi.approveOrRejectCustomerActivation(this.selectedItem.item.userId, Approve).subscribe({
      next: (v: GenericResponse) => {
        if (v.success) {
          this.goBackToSearchScreen()
        } else {
          this.showAlertBox('Sorry', 'There were some technical issues. Please contact the technical support team.')
        }
      },
      error: (e) => {
        this.showAlertBox('Sorry', 'There were some technical issues. Please contact the technical support team.')
      }
    })
  }

  

  alertVisibility(event: any){
    this.bAlert = event.state
  }

  getCifDetails(){
    this.searchBtnColor = 'primary'
    this.showAllPendingCustomerBtnColor = 'secondary'

    if (this.cifSearchForm.controls['searchCifControl'].value != null)
    {
      this.searchCif = this.cifSearchForm.controls['searchCifControl'].value
    }
    
    if (this.searchCif === '') {
      this.showAlertBox('Oops!!', 'You need to enter a valid CIF')
      return
    }

    this.selectedCif = this.searchCif

    this.bLoading = true

    this.restApi.getCifDetails({cif:this.searchCif}).subscribe({
      next: (v: CifDetails) => {
        if (v.success)
        {
          if (v.customerDetailsRes.responseCode === "000")
          {
            if (v.customerDetailsRes.ciftype === "COMPANY")
            {
              this.companyId = v.companyId
              this.companyName = v.customerDetailsRes.name1 + ', ' + v.customerDetailsRes.street + ', ' + v.customerDetailsRes.towncountry 
              this.getCustomers(this.searchCif)
            }
            else
            {
              this.bLoading = false
              this.showAlertBox("Error", "The CIF " + this.searchCif + " is not a valid company. Please try with other CIF number")
            }
          }
        }
        else
        {
          if (v.customerDetailsRes.responseCode === "0025")
          {
            this.bLoading = false
            this.showAlertBox("Error", "No customers found for the provided CIF.")
          }
          else 
          {
            this.bLoading = false
            this.showAlertBox("Error", "Oops! There was an error getting data from Middleware. Have patience and try after some time.")
          }
        }
        
      },
      error: (e) => {
        this.bLoading = false
        this.showAlertBox("Error", "Oops! Something went wrong. Have patience and try after some time.")
      },
    })
  }

  rowSelected = (clickedItem: any) =>{
    // Don't proceed if the active/inactive decision is pending
    if (clickedItem.item.isActiveDeactiveRequestPending) {
      //this.showAlertBox('Please confirm!', 'There is a request to ACTIVATE the customer. Do you want to Approve?', 'No, Reject', true, 'Yes, Approve', {action: 2, matrixId: 0});
      this.showActivationReasonModal(clickedItem);
      return;
    }

    this.companyName = 'Customer: ' + clickedItem.item.name + " (CIF: " + clickedItem.item.cif + ")"

    this.selectedCif = clickedItem.item.cif

    if (!clickedItem.item.isDecisionTaken)
      this.bIsProfilePending = true

    this.selectedCustomerAuthorityLevel = 'CIF'

    this.resetCommomPermissions()
    this.resetMatrixControls()

    this.bSelectedCustomerCIFLevelAuthority = false
    this.bIsSelectedCustomerMaker = false
    this.bSelectedCustomerCreateSB = false
    this.bSelectedCustomerCreateCurrent = false
    this.bSelectedCustomerRequestCertificate = false
    this.bSelectedCustomerChangeMobile = false
    this.bSelectedCustomerChangeAddress = false
    this.bSelectedCustomerChangeEmail = false
    this.bSelectedCustomerFullMasterAuthority = false
  
    // CIF Level Authorities
    this.bSelectedCustomerViewOnly = false
    this.bSelectedCustomerDeactivateAccount = false
    this.bSelectedCustomerCanCreateFD = false
    this.bSelectedCustomerUnlimitedFDThreshold = false
    this.bSelectedCustomerCanMakeInternalTransfer = false
    this.bSelectedCustomerUnlimitedInternalTransferThreshold = false
    this.bSelectedCustomerCanMakeDhabiTransfer = false
    this.bSelectedCustomerUnlimitedDhabiTransferThreshold = false
    this.bSelectedCustomerCanMakeForeignTransfer = false
    this.bSelectedCustomerUnlimitedForeignTransferThreshold = false

    // Account Level Details
    this.SelectedCustomerAccount = ''

    this.selectedTab = 0
    this.profileTabActive = true
    this.matrixTabActive = false
    this.bHasCustomerMatrixApprovalPending = false

    this.SelectedCustomerAccountPermissions = []
    
    this.selectedItem = clickedItem

    // Keep a deep copy
    this.originalCustomerDetails = _.cloneDeep(clickedItem)
    //console.log(this.selectedItem.item)

    if (this.selectedItem.item.approvalMatrices != undefined){
      this.selectedItem.item.approvalMatrices.every((element: any) => {
        if (!element.isDecisionTaken){
          this.bHasCustomerMatrixApprovalPending = true
          return false
        }

        return true
      })
    }

    this.selectedCustomerAuthorityLevel = this.getSelectedAuthorityLevel()
    this.selectedCustomerNationality = this.resolveNationalityShortCode(this.selectedItem.item.nationalityCountryCode)

    this.bShowCifSearchScreen = false
    this.bShowCustomerDetailsScreen = true

    this.selectedCustomerDateOfBirth = new Date(this.selectedItem.item.dateOfBirth)
    this.selectedCustomerIDExpiresOn = new Date(this.selectedItem.item.expiresOn)
    this.selectedCustomerGender = this.getSelectedGender()
    this.selectedCustomerIDType = this.getSelectedIDType()
    this.selectedCustomerRole = this.getSelectedRole()

    this.customerProfileForm = new FormGroup({
      customerName: new FormControl(this.selectedItem.item.name),
      customerEmail: new FormControl(this.selectedItem.item.emailId),
      customerMobile: new FormControl(this.selectedItem.item.mobileNumber),
      customeGender: new FormControl(this.selectedCustomerGender),
      customeDateOfBirth: new FormControl(this.selectedCustomerDateOfBirth),
      customerIDType: new FormControl(this.selectedCustomerIDType),
      customerIDNumber: new FormControl(this.selectedItem.item.eidNumber),
      customerNationality: new FormControl(this.selectedCustomerNationality),
      customerIDExpiryDate: new FormControl(this.selectedCustomerIDExpiresOn)
    })

    
console.log(this.selectedItem.item.isDecisionTaken)
    if (!this.selectedItem.item.isDecisionTaken)
      this.getCustomerProfile()

    this.customerProfileForm.disable()
  }

  get customerName() { return this.customerProfileForm.get('customerName') }
  get customerEmail() { return this.customerProfileForm.get('customerEmail')}
  get customerMobile() { return this.customerProfileForm.get('customerMobile')}
  get customeGender() { return this.customerProfileForm.get('customeGender')}
  get customeDateOfBirth() { return this.customerProfileForm.get('customeDateOfBirth')}
  get customerIDType() { return this.customerProfileForm.get('customerIDType')}
  get customerIDNumber() { return this.customerProfileForm.get('customerIDNumber')}
  get customerNationality() { return this.customerProfileForm.get('customerNationality')}
  get customerIDExpiryDate() { return this.customerProfileForm.get('customerIDExpiryDate')}

  getCustomerProfile(){
    this.restApi.getUserProfile(this.selectedItem.item.userId).subscribe({
      next:(v: UserProfile) => {
        console.log("Got User Profile")
        console.log(v)

        this.approvedCustomerProfile = v
        if(v.isNew == true)
        {
          this.bHasCustomerMatrixApprovalPending = false;
          this.showApprovedOrPendingScreen(false);
        }
        this.customerName?.setValue(v.name)
        this.customerEmail?.setValue(v.emailId)
        this.customerMobile?.setValue(v.mobileNumber)
        this.customeGender?.setValue(v.genderId == 1?'Male':'Female')
        this.customeDateOfBirth?.setValue(new Date(v.dateOfBirth))
        this.customerIDType?.setValue(v.isEID?'Emirates ID':'Passport')
        this.customerIDNumber?.setValue(v.eidNumber)
        const resolvedNationality = this.resolveNationalityShortCode(v.nationalityCountryCode)
        this.selectedCustomerNationality = resolvedNationality
        this.customerNationality?.setValue(resolvedNationality)
        this.customerIDExpiryDate?.setValue(new Date(v.expiresOn))

        this.selectedCustomerDateOfBirth = new Date(v.dateOfBirth)
        this.selectedCustomerIDExpiresOn = new Date(v.expiresOn)

        if (this.approvedCustomerProfile.name != this.approvedCustomerProfile.oldName)
          this.bApprovedName = true

        if (this.approvedCustomerProfile.emailId != this.approvedCustomerProfile.oldEmailId)
          this.bApprovedEmail = true

        if (this.approvedCustomerProfile.mobileNumber != this.approvedCustomerProfile.oldMobileNumber)
          this.bApprovedMobile = true

        if (this.approvedCustomerProfile.genderId != this.approvedCustomerProfile.oldGenderId)
          this.bApprovedGender = true

        if (this.approvedCustomerProfile.dateOfBirth != this.approvedCustomerProfile.oldDateOfBirth)
          this.bApprovedDOB = true

        if (this.approvedCustomerProfile.isEID != this.approvedCustomerProfile.wasEID)
          this.bApprovedIDType = true

        if (this.approvedCustomerProfile.eidNumber != this.approvedCustomerProfile.oldEIDNumber)
          this.bApprovedIDNumber = true

        if (this.approvedCustomerProfile.nationalityCountryCode != this.approvedCustomerProfile.oldNationalityCountryCode)
          this.bApprovedNationality = true

        if (this.approvedCustomerProfile.expiresOn != this.approvedCustomerProfile.oldExpiresOn)
          this.bApprovedIDExpiry = true

        this.bShowingApprovedName = true
        this.bShowingApprovedDOB = true
        this.bShowingApprovedEmail = true
        this.bShowingApprovedGender = true
        this.bShowingApprovedIDExpiry = true
        this.bShowingApprovedIDNumber = true
        this.bShowingApprovedIDType = true
        this.bShowingApprovedMobile = true
        this.bShowingApprovedNationaility = true

      },
      error: (e) => {

      }
    })
  }

  bApprovedName: boolean = false
  bShowingApprovedName: boolean = true

  bApprovedEmail: boolean = false
  bShowingApprovedEmail: boolean = true

  bApprovedMobile: boolean = false
  bShowingApprovedMobile: boolean = true

  bApprovedGender: boolean = false
  bShowingApprovedGender: boolean = true

  bApprovedDOB: boolean = false
  bShowingApprovedDOB: boolean = true

  bApprovedIDType: boolean = false
  bShowingApprovedIDType: boolean = true

  bApprovedIDNumber: boolean = false
  bShowingApprovedIDNumber: boolean = true

  bApprovedNationality: boolean = false
  bShowingApprovedNationaility: boolean = true

  bApprovedIDExpiry: boolean = false
  bShowingApprovedIDExpiry: boolean = true

  showApprovedProfile(event:any, controlId: number){
    event.stopPropagation()
    event.preventDefault()

    if (this.approvedCustomerProfile != null){
      switch (controlId){
        case 1:
          this.bShowingApprovedName = !this.bShowingApprovedName

          if (this.bShowingApprovedName)
            this.customerName?.setValue(this.selectedItem.item.name)
          else
            this.customerName?.setValue(this.approvedCustomerProfile.oldName)

          break;
        case 2:
          this.bShowingApprovedEmail = !this.bShowingApprovedEmail
          
          if (this.bShowingApprovedEmail)
            this.customerEmail?.setValue(this.approvedCustomerProfile.emailId)
          else
            this.customerEmail?.setValue(this.approvedCustomerProfile.oldEmailId)
          
          break;
        case 3:
          this.bShowingApprovedMobile = !this.bShowingApprovedMobile

          if (this.bShowingApprovedMobile)
            this.customerMobile?.setValue(this.approvedCustomerProfile.mobileNumber)
          else
            this.customerMobile?.setValue(this.approvedCustomerProfile.oldMobileNumber)
          
          break;
        case 4:
          this.bShowingApprovedGender = !this.bShowingApprovedGender

          if (this.bShowingApprovedGender)
            this.customeGender?.setValue(this.approvedCustomerProfile.genderId == 1?'Male':'Female')
          else
            this.customeGender?.setValue(this.approvedCustomerProfile.oldGenderId == 1?'Male':'Female')
          
          break;
        case 5:
          this.bShowingApprovedDOB = !this.bShowingApprovedDOB
          if (this.bShowingApprovedDOB)
            this.customeDateOfBirth?.setValue(this.approvedCustomerProfile.dateOfBirth)
          else
            this.customeDateOfBirth?.setValue(this.approvedCustomerProfile.oldDateOfBirth)
          
          break;
        case 6:
          this.bShowingApprovedIDType = !this.bShowingApprovedIDType

          if (this.bShowingApprovedIDType)
            this.customerIDType?.setValue(this.approvedCustomerProfile.isEID?'Emirates ID':'Passport')
          else
            this.customerIDType?.setValue(this.approvedCustomerProfile.wasEID?'Emirates ID':'Passport')
          
          break;
        case 7:
          this.bShowingApprovedIDNumber = !this.bShowingApprovedIDNumber

          if (this.bShowingApprovedIDNumber)
            this.customerIDNumber?.setValue(this.approvedCustomerProfile.eidNumber)
          else
            this.customerIDNumber?.setValue(this.approvedCustomerProfile.oldEIDNumber)
          
          break;
        case 8:
          this.bShowingApprovedNationaility = !this.bShowingApprovedNationaility

          if (this.bShowingApprovedNationaility)
            this.customerNationality?.setValue(this.resolveNationalityShortCode(this.approvedCustomerProfile.nationalityCountryCode))
          else
            this.customerNationality?.setValue(this.resolveNationalityShortCode(this.approvedCustomerProfile.oldNationalityCountryCode))
          
          break;
        case 9:
          this.bShowingApprovedIDExpiry = !this.bShowingApprovedIDExpiry

          if (this.bShowingApprovedIDExpiry)
            this.customerIDExpiryDate?.setValue(this.approvedCustomerProfile.expiresOn)
          else
            this.customerIDExpiryDate?.setValue(this.approvedCustomerProfile.oldExpiresOn)
          
          break;
      }
      
    }
  }

  getSelectedGender() {
    switch(this.selectedItem.item.genderId) {
      case 1:
        return 'Male'
      case 2:
        return 'Female'
      default:
        return 'Male'
    }
  }

  getSelectedIDType() {
    switch(this.selectedItem.item.isEID) {
      case true:
        return 'Emirates ID'
      case false:
        return 'Passport'
      default:
        return 'Unknown'
    }
  }

  getSelectedRole() {
    if (this.selectedItem.item.approvalMatrices != undefined && this.selectedItem.item.approvalMatrices.length != 0) {
  this.bIsSelectedCustomerAuthorityDefined = true

      var tempRole = ''

      this.selectedItem.item.approvalMatrices.every((element: any) => {
        if ((this.bShowingApprovedData && element.isDecisionTaken) || (!this.bShowingApprovedData && !element.isDecisionTaken)){
          // First see if there 'enable' requests
          if (element.enable && element.isMaker){
            tempRole =  'Maker'
            return false
          }
          else if (element.enable && !element.isMaker){
            tempRole =  'Checker'
            return false
          }

          if (element.isMaker)
            tempRole =  'Maker'
          else if (!element.isMaker)
            tempRole =  'Checker'
        } else {
          // First see if there 'enable' requests
          if (!element.enable && element.isMaker){
            tempRole =  'Maker'
            return false
          }
          else if (!element.enable && !element.isMaker){
            tempRole =  'Checker'
            return false
          }

          if (element.isMaker)
            tempRole =  'Maker'
          else if (!element.isMaker)
            tempRole =  'Checker'
        }
        

        return true
      })

      if (tempRole === 'Maker')
        this.bIsSelectedCustomerMaker = true
      else
        this.bIsSelectedCustomerMaker = false

      return tempRole
    }

    this.bIsSelectedCustomerAuthorityDefined = false

    this.showAlertBox("Warning", "This customer does not have any authority matrix defined")

    return ''
  }

  getSelectedAuthorityLevel() { 
    let authorityLevel = " "

    if (this.selectedItem.item.approvalMatrices != undefined && this.selectedItem.item.approvalMatrices.length != 0) {
      this.bIsSelectedCustomerAuthorityDefined = true

      // Now get the Master Authorities
      this.selectedItem.item.approvalMatrices.forEach((element: any) => {
                if ((this.bShowingApprovedData && element.isDecisionTaken) || (!this.bShowingApprovedData && !element.isDecisionTaken))
        {
          switch (element.matrixId){
            case 2:
              this.bSelectedCustomerCreateSB = element.enable
              break;
            case 3:
              this.bSelectedCustomerCreateCurrent = element.enable
              break;
            case 4:
              this.bSelectedCustomerChangeAddress = element.enable
              break;
            case 5:
              this.bSelectedCustomerChangeMobile = element.enable
              break;
            case 6:
              this.bSelectedCustomerChangeEmail = element.enable
              break;
            case 9:
              this.bSelectedCustomerRequestCertificate = element.enable
              break;
          }
        }
      });

      if (this.bSelectedCustomerChangeAddress &&
          // this.bSelectedCustomerChangeEmail &&
          // this.bSelectedCustomerChangeMobile &&
          this.bSelectedCustomerCreateCurrent &&
          this.bSelectedCustomerCreateSB &&
          this.bSelectedCustomerRequestCertificate)
        this.bSelectedCustomerFullMasterAuthority = true

      //console.log("Authority Level: " + this.selectedItem.item.approvalMatrices[0].isCIFLevelAuthority)

      this.selectedItem.item.approvalMatrices.every((element: any) => {
          if (this.bShowingApprovedData && this.bHasCustomerMatrixApprovalPending) {
          if (!element.enable && element.isCIFLevelAuthority) {
            authorityLevel =  'CIF'
            return false
          }
          else if (!element.enable && !element.isCIFLevelAuthority){
            authorityLevel =  'Account'
            return false
          }

          if (element.isCIFLevelAuthority){
            authorityLevel =  'CIF'
          }
          else if (!element.isCIFLevelAuthority){
            authorityLevel =  'Account'
          }
        } else {
          if (element.enable && element.isCIFLevelAuthority) {
            authorityLevel =  'CIF'
            return false
          }
          else if (element.enable && !element.isCIFLevelAuthority){
            authorityLevel =  'Account'
            return false
          }

          if (element.isCIFLevelAuthority){
            authorityLevel =  'CIF'
          }
          else if (!element.isCIFLevelAuthority){
            authorityLevel =  'Account'
          }
        }
        return true
      })

      if (authorityLevel == 'CIF'){
        this.bSelectedCustomerCIFLevelAuthority = true
        this.authorityLevelTabLabel = 'CIF Level Authorities'
      } else {
        this.bSelectedCustomerCIFLevelAuthority = false
        this.SelectedCustomerAccountPermissions = this.selectedItem.item.approvalMatrices
        this.getCompanyAccounts(this.selectedCif)
      }

      if (this.bSelectedCustomerCIFLevelAuthority){
        this.resetCifThresholdState()

        // Now get the CIF Level Authorities
        this.selectedItem.item.approvalMatrices.forEach((element: any) => {
          
          if ((this.bShowingApprovedData && element.isDecisionTaken) || (!this.bShowingApprovedData && !element.isDecisionTaken)){
            switch (element.matrixId){
              case 15:
                this.bSelectedCustomerViewOnly = element.enable
                break;
              case 16:
                this.bSelectedCustomerDeactivateAccount = element.enable
                break;
              case 1:
                this.setCifThresholdFromMatrix(element)

                break;
              case 14:
                this.setCifThresholdFromMatrix(element)
                break;
              case 12:
                this.setCifThresholdFromMatrix(element)

                break;
              case 13:
                this.setCifThresholdFromMatrix(element)

                break;
            }
          }
        });

        this.syncLegacyCifThresholdFromDefaultCurrency()
      }
      else
      {
        // Get the first account and set it
        // this.getFirstValidAccount()
      }

      return authorityLevel
    }

    this.bIsSelectedCustomerAuthorityDefined = false

    return ''
  }

  private isThresholdCIFMatrix(matrixId: number) {
    return matrixId === 1 || matrixId === 12 || matrixId === 13 || matrixId === 14
  }

  private normalizeCurrencyCode(currencyCode: string | undefined | null): CifCurrencyCode {
    const normalized = (currencyCode || this.cifSupportedCurrencies[0]).toUpperCase() as CifCurrencyCode
    if (this.cifSupportedCurrencies.includes(normalized)) {
      return normalized
    }
    return this.cifSupportedCurrencies[0]
  }

  private getDefaultCifThresholdCell(): CifThresholdCell {
    return {
      threshold: 0,
      unlimited: false,
      valid: this.bUndefined
    }
  }

  private ensureCifThresholdState() {
    this.cifThresholdRows.forEach((row) => {
      if (!this.cifThresholdState[row.matrixId]) {
        this.cifThresholdState[row.matrixId] = {}
      }

      this.cifSupportedCurrencies.forEach((currency) => {
        if (!this.cifThresholdState[row.matrixId][currency]) {
          this.cifThresholdState[row.matrixId][currency] = this.getDefaultCifThresholdCell()
        }
      })
    })
  }

  private resetCifThresholdState() {
    this.cifThresholdState = {}
    this.ensureCifThresholdState()
  }

  getCifThresholdCell(matrixId: number, currencyCode: string): CifThresholdCell {
    this.ensureCifThresholdState()
    const currency = this.normalizeCurrencyCode(currencyCode)
    return this.cifThresholdState[matrixId][currency]
  }

  getCifMatrixEnabled(matrixId: number): boolean {
    switch (matrixId) {
      case 1:
        return this.bSelectedCustomerCanCreateFD
      case 12:
        return this.bSelectedCustomerCanMakeDhabiTransfer
      case 13:
        return this.bSelectedCustomerCanMakeForeignTransfer
      case 14:
        return this.bSelectedCustomerCanMakeInternalTransfer
      default:
        return false
    }
  }

  isAllCifThresholdAuthoritiesEnabled(): boolean {
    return this.cifThresholdRows.every((row) => this.getCifMatrixEnabled(row.matrixId))
  }

  private setCifMatrixEnabled(matrixId: number, enabled: boolean) {
    switch (matrixId) {
      case 1:
        this.bSelectedCustomerCanCreateFD = enabled
        break
      case 12:
        this.bSelectedCustomerCanMakeDhabiTransfer = enabled
        break
      case 13:
        this.bSelectedCustomerCanMakeForeignTransfer = enabled
        break
      case 14:
        this.bSelectedCustomerCanMakeInternalTransfer = enabled
        break
    }
  }

  private setCifThresholdFromMatrix(element: any) {
    if (!this.isThresholdCIFMatrix(element.matrixId)) {
      return
    }

    const currency = this.normalizeCurrencyCode(element.currencyCode || element.currency)
    const cell = this.getCifThresholdCell(element.matrixId, currency)
    const isUnlimited = element.threshold == -1

    cell.unlimited = isUnlimited
    cell.threshold = isUnlimited ? 0 : (element.threshold || 0)
    cell.valid = this.bUndefined
    this.setCifMatrixEnabled(element.matrixId, this.getCifMatrixEnabled(element.matrixId) || !!element.enable)
  }

  private syncLegacyCifThresholdFromDefaultCurrency() {
    const defaultCurrency = this.cifSupportedCurrencies[0]

    const fdCell = this.getCifThresholdCell(1, defaultCurrency)
    this.SelectedCustomerFDThreshold = fdCell.threshold
    this.bSelectedCustomerUnlimitedFDThreshold = fdCell.unlimited
    this.bValidFDThreshold = fdCell.valid

    const internalCell = this.getCifThresholdCell(14, defaultCurrency)
    this.SelectedCustomerInternalTransferThreshold = internalCell.threshold
    this.bSelectedCustomerUnlimitedInternalTransferThreshold = internalCell.unlimited
    this.bValidInternalTxThreshold = internalCell.valid

    const dhabiCell = this.getCifThresholdCell(12, defaultCurrency)
    this.SelectedCustomerDhabiTransferThreshold = dhabiCell.threshold
    this.bSelectedCustomerUnlimitedDhabiTransferThreshold = dhabiCell.unlimited
    this.bValidDhabiTxThreshold = dhabiCell.valid

    const foreignCell = this.getCifThresholdCell(13, defaultCurrency)
    this.SelectedCustomerForeignTransferThreshold = foreignCell.threshold
    this.bSelectedCustomerUnlimitedForeignTransferThreshold = foreignCell.unlimited
    this.bValidForeignTxThreshold = foreignCell.valid
  }

  getCompanyAccounts(Cif: string){
    this.restApi.getCompanyAccounts({cif:this.selectedCif}).subscribe({
      next: (v: GetCompanyAccounts) => {
        const normalized = this.normalizeCompanyAccounts(v.accounts)
        this.companyAccounts = normalized.accountNumbers
        this.accountCurrencyByNumber = normalized.currencyByAccount

        // Get the first account and set it
        this.getFirstValidAccount()
        this.authorityLevelTabLabel = 'Account Level Authorities'
        this.buildAccountMatrixGrid()
      },
      error: (e) => {
        this.showAlertBox('Sorry', 'Unable to retrieve account details of this company. Please contact support.')
      }
    })
  }

  private normalizeCompanyAccounts(accounts: GetCompanyAccounts['accounts']): { accountNumbers: string[], currencyByAccount: { [accountNumber: string]: string } } {
    const currencyByAccount: { [accountNumber: string]: string } = {}

    if (Array.isArray(accounts)) {
      accounts.forEach((accountNumber: string) => {
        currencyByAccount[accountNumber] = 'USD'
      })
      return {
        accountNumbers: accounts,
        currencyByAccount
      }
    }

    Object.entries(accounts || {}).forEach(([accountNumber, currency]) => {
      currencyByAccount[accountNumber] = (currency || 'USD').toUpperCase()
    })

    return {
      accountNumbers: Object.keys(currencyByAccount),
      currencyByAccount
    }
  }

  // Build the read-only account grid from company accounts and the customer's account-level matrices
  buildAccountMatrixGrid() {
    const permissions = this.SelectedCustomerAccountPermissions || []
    const matchesView = (m: any) =>
      (this.bShowingApprovedData && m.isDecisionTaken) ||
      (!this.bShowingApprovedData && !m.isDecisionTaken)

    const buildCell = (matches: any[], matrixId: number) => {
      const m = matches.find((x: any) => x.matrixId === matrixId)
      if (!m) {
        return { enabled: false, threshold: 0, unlimited: false }
      }
      const isUnlimited = m.threshold === -1
      return {
        enabled: !!m.enable,
        threshold: isUnlimited ? 0 : (m.threshold || 0),
        unlimited: isUnlimited
      }
    }

    this.accountMatrixRows = (this.companyAccounts || []).map((accountNumber: string) => {
      const forAccount = permissions.filter((m: any) =>
        !m.isCIFLevelAuthority && m.accountNumber === accountNumber && matchesView(m)
      )
      const fd = buildCell(forAccount, 1)
      const internal = buildCell(forAccount, 14)
      const dhabi = buildCell(forAccount, 12)
      const foreign = buildCell(forAccount, 13)
      return {
        accountNumber,
        currency: (this.accountCurrencyByNumber[accountNumber] || 'USD').toUpperCase(),
        rowEnabled: fd.enabled || internal.enabled || dhabi.enabled || foreign.enabled,
        fd, internal, dhabi, foreign
      }
    })

    const rows = this.accountMatrixRows
    this.allAccountsSelected = rows.length > 0 && rows.every(r => r.rowEnabled)
  }

  getFirstValidAccount(){
    if (this.selectedItem.item.approvalMatrices != undefined) {
      // Initially set this
      this.authorityLevelTabLabel = 'Permissions For Account : ' + this.SelectedCustomerAccount

      this.selectedItem.item.approvalMatrices.forEach((element: any) => {
        if (element.accountNumber != undefined && element.accountNumber != '') {
          if(this.bShowingApprovedData == false && element.isDecisionTaken == false)
            {
              this.SelectedCustomerAccount =  element.accountNumber
            }
            if(this.bShowingApprovedData == true && element.isDecisionTaken == true)
            {
              this.SelectedCustomerAccount =  element.accountNumber
            }
          this.setAccountMatrices()
          this.authorityLevelTabLabel = 'Permissions For Account : ' + this.SelectedCustomerAccount
          return
        }
      });
    }
  }

  setAccountMatrices(){
    this.resetMatrixControls()

    this.SelectedCustomerAccountPermissions.forEach((element: any) => {


      if (element.accountNumber === this.SelectedCustomerAccount)
      {
        if ((this.bShowingApprovedData && element.isDecisionTaken && element.enable)){
          switch (element.matrixId){
            case 15:
              this.bSelectedCustomerViewOnly = element.enable
              break;
            case 16:
              this.bSelectedCustomerDeactivateAccount = element.enable
              break;
            case 1:
              this.bSelectedCustomerCanCreateFD = element.enable

              if (element.threshold == -1)
              {
                this.bSelectedCustomerUnlimitedFDThreshold = true
                this.SelectedCustomerFDThreshold = 0
              }
              else
              {
                this.bSelectedCustomerUnlimitedFDThreshold = false
                this.SelectedCustomerFDThreshold = element.threshold
              }

              break;
            case 14:
              this.bSelectedCustomerCanMakeInternalTransfer = element.enable
              
              if (element.threshold == -1)
              {
                this.bSelectedCustomerUnlimitedInternalTransferThreshold = true
                this.SelectedCustomerInternalTransferThreshold = 0
              }
              else
              {
                this.bSelectedCustomerUnlimitedInternalTransferThreshold = false
                this.SelectedCustomerInternalTransferThreshold = element.threshold
              }
              break;
            case 12:
              this.bSelectedCustomerCanMakeDhabiTransfer = element.enable

              if (element.threshold == -1)
              {
                this.bSelectedCustomerUnlimitedDhabiTransferThreshold = true
                this.SelectedCustomerDhabiTransferThreshold = 0
              }
              else
              {
                this.bSelectedCustomerUnlimitedDhabiTransferThreshold = false
                this.SelectedCustomerDhabiTransferThreshold = element.threshold
              }

              break;
            case 13:
              this.bSelectedCustomerCanMakeForeignTransfer = element.enable

              if (element.threshold == -1)
              {
                this.bSelectedCustomerUnlimitedForeignTransferThreshold = true
                this.SelectedCustomerForeignTransferThreshold = 0
              }
              else
              {
                this.bSelectedCustomerUnlimitedForeignTransferThreshold = false
                this.SelectedCustomerForeignTransferThreshold = element.threshold
              }

              break;
          }
        } else if (!this.bShowingApprovedData && !element.isDecisionTaken && element.enable){
          switch (element.matrixId){
            case 15:
              this.bSelectedCustomerViewOnly = element.enable
              break;
            case 16:
              this.bSelectedCustomerDeactivateAccount = element.enable
              break;
            case 1:
              this.bSelectedCustomerCanCreateFD = element.enable

              if (element.threshold == -1)
              {
                this.bSelectedCustomerUnlimitedFDThreshold = true
                this.SelectedCustomerFDThreshold = 0
              }
              else
              {
                this.bSelectedCustomerUnlimitedFDThreshold = false
                this.SelectedCustomerFDThreshold = element.threshold
              }

              break;
            case 14:
              this.bSelectedCustomerCanMakeInternalTransfer = element.enable
              
              if (element.threshold == -1)
              {
                this.bSelectedCustomerUnlimitedInternalTransferThreshold = true
                this.SelectedCustomerInternalTransferThreshold = 0
              }
              else
              {
                this.bSelectedCustomerUnlimitedInternalTransferThreshold = false
                this.SelectedCustomerInternalTransferThreshold = element.threshold
              }
              break;
            case 12:
              this.bSelectedCustomerCanMakeDhabiTransfer = element.enable

              if (element.threshold == -1)
              {
                this.bSelectedCustomerUnlimitedDhabiTransferThreshold = true
                this.SelectedCustomerDhabiTransferThreshold = 0
              }
              else
              {
                this.bSelectedCustomerUnlimitedDhabiTransferThreshold = false
                this.SelectedCustomerDhabiTransferThreshold = element.threshold
              }

              break;
            case 13:
              this.bSelectedCustomerCanMakeForeignTransfer = element.enable

              if (element.threshold == -1)
              {
                this.bSelectedCustomerUnlimitedForeignTransferThreshold = true
                this.SelectedCustomerForeignTransferThreshold = 0
              }
              else
              {
                this.bSelectedCustomerUnlimitedForeignTransferThreshold = false
                this.SelectedCustomerForeignTransferThreshold = element.threshold
              }

              break;
          }
        }
        
      }
    });
  }

  getRoleBadge(item: any){
    if (item.approvalMatrices != undefined && item.approvalMatrices[0] != undefined) {
      if (item.approvalMatrices[0].isMaker)
        return 'primary'
      else
        return 'secondary'
    } else {
      return 'danger'
    }
  }
  getDateDisplayString(item: any){
    let displayDate = '';
    if (item.approvalMatrices != undefined && item.approvalMatrices[0] != undefined) {
      let displayDate = this.datePipe.transform(item.approvalMatrices[0].createdOn,"dd-MM-yyyy")
      if (item.approvalMatrices[0].createdOn){
        
        return displayDate
      }else{
        return displayDate
      }
    }else {
      return displayDate
    console.log(item)
    }
  }
  getRole(item: any){
    //console.log(item)
    if (item.approvalMatrices != undefined && item.approvalMatrices[0] != undefined) {
      if (item.approvalMatrices[0].isMaker)
        return 'Maker'
      else
        return 'Checker'
    } else {
      return 'Unknown'
    }
  }

  getAuthorityLevelBadge(item: any){
    if (item.approvalMatrices != undefined && item.approvalMatrices[0] != undefined) {
      if (item.approvalMatrices[0].isCIFLevelAuthority)
        return 'primary'
      else
        return 'secondary'
    } else {
      return 'danger'
    }
  }

  getAuthorityLevel(item: any){
    if (item.approvalMatrices != undefined && item.approvalMatrices[0] != undefined) {
      let authorityLevel = ''

      item.approvalMatrices.every((element: any) => {
        // First see if there 'enable' requests
        if (element.enable && element.isCIFLevelAuthority) {
          authorityLevel =  'CIF'
          return false
        }
        else if (element.enable && !element.isCIFLevelAuthority){
          authorityLevel =  'Account'
          return false
        }

        if (element.isCIFLevelAuthority){
          authorityLevel =  'CIF'
        }
        else if (!element.isCIFLevelAuthority){
          authorityLevel =  'Account'
        }

        return true
      })

      return authorityLevel
    } else {
      return 'Unknown'
    }
  }

  getStatusBadge(item: any) {
    if (item.isActiveDeactiveRequestPending) {
      return 'danger'
    } else {
      if ((item.isDecisionTaken && item.approvalMatrices.length != 0 && item.approvalMatrices[0].isDecisionTaken) && !item.isActive){
        return 'danger'
      } else {
        if (item.approvalMatrices != undefined && item.approvalMatrices[0] != undefined) {
          if (item.isDecisionTaken && item.isApproved && item.approvalMatrices[0].isDecisionTaken && item.approvalMatrices[0].isApproved)
            return 'success'
          else if ((item.isDecisionTaken && !item.isApproved) || (item.approvalMatrices[0].isDecisionTaken && !item.approvalMatrices[0].isApproved))
            return 'danger'
          else if (!item.isDecisionTaken || !item.approvalMatrices[0].isDecisionTaken)
            return 'warning'
          else
            return 'primary'
        } else  {
            return 'danger'
        }
      }
    }
    // if (item.isActiveDeactiveRequestPending) {
    //   return 'danger'
    // } else {
    //   if ((item.isDecisionTaken && item.approvalMatrices.length != 0 && item.approvalMatrices[0].isDecisionTaken) && !item.isActive){
    //     return 'danger'
    //   } else {
    //     if (item.approvalMatrices != undefined && item.approvalMatrices[0] != undefined) {
    //       if (item.isDecisionTaken && item.isApproved && item.approvalMatrices[0].isDecisionTaken && item.approvalMatrices[0].isApproved)
    //         return 'success'
    //       else if ((item.isDecisionTaken && !item.isApproved) || (item.approvalMatrices[0].isDecisionTaken && !item.approvalMatrices[0].isApproved))
    //         return 'danger'
    //       else if (!item.isDecisionTaken || !item.approvalMatrices[0].isDecisionTaken)
    //         return 'warning'
    //       else
    //         return 'primary'
    //     } else  {
    //         return 'danger'
    //     }
    //   }
    // }
  }

  getStatus(item: any) {
    if (item.isActiveDeactiveRequestPending) {
      return 'Active/Inactive Decision Pending'
    } else {
      if ((item.isDecisionTaken && item.approvalMatrices.length != 0 && item.approvalMatrices[0].isDecisionTaken) && !item.isActive){
        return 'Inactive Customer'
      } else {
        if (item.approvalMatrices != undefined && item.approvalMatrices[0] != undefined) {
          if (item.isDecisionTaken && item.isApproved && item.approvalMatrices[0].isDecisionTaken && item.approvalMatrices[0].isApproved)
          return 'Approved'
          else if ((item.isDecisionTaken && !item.isApproved) || (item.approvalMatrices[0].isDecisionTaken && !item.approvalMatrices[0].isApproved))
            return 'Rejected'
          else if (!item.isDecisionTaken || !item.approvalMatrices[0].isDecisionTaken)
            return 'No Decision Taken'
          else
            return 'Unknown'
        } else {
            return 'Incomplete'
        }
      }
    }
  }

  getCustomers(Cif: string){
    this.restApi.getPendingCorporateCustomers({cif:this.searchCif}).subscribe({
      next: (v: CorporateUserDetails) => {
        this.bLoading = false
        this.usersData = v.corporateUsers.map((item, UserId) => {
          const _selected = this.selectedItems.includes(UserId);
          return {
            ...item,
            _selected
          };
        })
      },
      error: (e) => {
        this.bLoading = false
      }
    })
  }

  getAllPendingCustomers(){
    this.searchBtnColor = 'secondary'
    this.showAllPendingCustomerBtnColor = 'primary'
    this.cifSearchForm.reset();
    this.restApi.getPendingCorporateCustomers({cif:'ALL'}).subscribe({
      next: (v: CorporateUserDetails) => {
        this.bLoading = false
        this.usersData = v.corporateUsers.map((item, UserId) => {
          const _selected = this.selectedItems.includes(UserId);
          return {
            ...item,
            _selected
          };
        })
      },
      error: (e) => {
        this.bLoading = false
      }
    })
  }

  goBackToSearchScreen(){
      this.bShowCifSearchScreen = true
      this.bShowCustomerDetailsScreen = false
      this.resetCommomPermissions()
      this.resetMatrixControls()
      this.SelectedCustomerAccountPermissions = []
      this.selectedItem = []

      this.companyName = ''

      if (this.showAllPendingCustomerBtnColor == 'secondary')
        this.getCifDetails()
      else
        this.getAllPendingCustomers()
    
  }

  resetCommomPermissions() {
    this.bSelectedCustomerCreateSB = false
    this.bSelectedCustomerCreateCurrent = false
    this.bSelectedCustomerRequestCertificate = false
    //this.bSelectedCustomerChangeMobile = false
    this.bSelectedCustomerChangeAddress = false
    //this.bSelectedCustomerChangeEmail = false
    this.bSelectedCustomerFullMasterAuthority = false
  }

  resetMatrixControls() {
    this.bSelectedCustomerViewOnly = false
    this.bSelectedCustomerDeactivateAccount = false
    this.bSelectedCustomerCanCreateFD= false
    this.bSelectedCustomerUnlimitedFDThreshold = false
    this.bSelectedCustomerCanMakeInternalTransfer = false
    this.bSelectedCustomerUnlimitedInternalTransferThreshold = false
    this.bSelectedCustomerCanMakeDhabiTransfer = false
    this.bSelectedCustomerUnlimitedDhabiTransferThreshold = false
    this.bSelectedCustomerCanMakeForeignTransfer = false
    this.bSelectedCustomerUnlimitedForeignTransferThreshold = false

    this.SelectedCustomerFDThreshold = 0
    this.SelectedCustomerInternalTransferThreshold = 0
    this.SelectedCustomerDhabiTransferThreshold = 0
    this.SelectedCustomerForeignTransferThreshold = 0

    this.bValidFDThreshold = this.bUndefined
    this.bValidInternalTxThreshold = this.bUndefined
    this.bValidDhabiTxThreshold = this.bUndefined
    this.bValidForeignTxThreshold = this.bUndefined

    this.resetCifThresholdState()
  }

  activeTabPaneIdxChange(event: any){
    if (event == 0)
    {
      this.selectedTab = 0
      this.profileTabActive = true
      this.matrixTabActive = false
    }
    else if (event == 1)
    {
      this.selectedTab = 1
      this.profileTabActive = false
      this.matrixTabActive = true
    }
  }

  onChangeAccount(){
    this.setAccountMatrices()
    this.authorityLevelTabLabel = 'Permissions For Account : ' + this.SelectedCustomerAccount
  }

  topScreenMessage: string = 'You are looking at the approved permissions of this customer. Click to see the permissions pending approval.'

  showApprovedOrPendingScreen(value: boolean) {
    this.bShowingApprovedData = value

    if (value)
      this.topScreenMessage = 'You are looking at the approved permissions of this customer. Click to see the permissions pending approval.'
    else
      this.topScreenMessage = 'Now showing only the permissions which are pending approval. Click to see the approved permissions.'

    this.reloadCustomer()
  }

  reloadCustomer(){
    console.log(this.originalCustomerDetails.item)
    this.resetCommomPermissions()
    this.resetMatrixControls()
    this.SelectedCustomerAccountPermissions = []

    // Copy back
    this.selectedItem = _.cloneDeep(this.originalCustomerDetails)

    this.selectedCustomerDateOfBirth = new Date(this.selectedItem.item.dateOfBirth)
    this.selectedCustomerIDExpiresOn = new Date(this.selectedItem.item.expiresOn)
    this.selectedCustomerGender = this.getSelectedGender()
    this.selectedCustomerIDType = this.getSelectedIDType()
    this.selectedCustomerRole = this.getSelectedRole()
    this.selectedCustomerAuthorityLevel = this.getSelectedAuthorityLevel()
    this.selectedCustomerNationality = this.resolveNationalityShortCode(this.selectedItem.item.nationalityCountryCode)

    this.customerName?.setValue(this.selectedItem.item.name)
    this.customerEmail?.setValue(this.selectedItem.item.emailId)
    this.customerMobile?.setValue(this.selectedItem.item.mobileNumber)
    this.customeGender?.setValue(this.selectedCustomerGender)
    this.customeDateOfBirth?.setValue(this.selectedCustomerDateOfBirth)
    this.customerIDType?.setValue(this.selectedCustomerIDType)
    this.customerIDNumber?.setValue(this.selectedItem.item.eidNumber)
    this.customerNationality?.setValue(this.resolveNationalityShortCode(this.selectedCustomerNationality))
    this.customerIDExpiryDate?.setValue(this.selectedCustomerIDExpiresOn)

    this.bShowCifSearchScreen = false
    this.bShowCustomerDetailsScreen = true
  }
}
